import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi, { ICreateOrUpdateBorrowerRequest } from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createCreateBorrowerThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(
    ApplyProcessActionTypes.CreateBorrower,
    async (data: ICreateOrUpdateBorrowerRequest) => {
      const response = await api.createBorrower(data);
      return response;
    },
  );
